import { render, staticRenderFns } from "./needs2.vue?vue&type=template&id=ed621c18&scoped=true&"
import script from "./needs2.vue?vue&type=script&lang=js&"
export * from "./needs2.vue?vue&type=script&lang=js&"
import style0 from "./needs2.vue?vue&type=style&index=0&id=ed621c18&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed621c18",
  null
  
)

export default component.exports